import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetAccountManagementSlice } from "../../redux/features/AccountManagement";
import {jwtDecode} from 'jwt-decode'

const Header = () => {
  const dispatch = useDispatch();
  const [iState, setUpdate] = useState({});

  const {UpdateDetails} = useSelector((state)=>state?.AccountManagement)

  console.log(UpdateDetails)

  let getToken = null;

  try {
    const token = localStorage.getItem('single_vendor_admin_token');
    if(token){
      getToken= jwtDecode(JSON.parse(token));
    }
  } catch (error) {
    getToken= null
  }

  console.log(getToken)

  useEffect(() => {
    dispatch(GetAccountManagementSlice(getToken?.id))?.then((res) => {
      console.log(res)
        console.log(res.payload?.data)
        setUpdate(res.payload?.data);
    });
  },[getToken?.id,UpdateDetails]);

  return (
    <>
      <div className="Header">
        <div className="Navigation">
          <div className="Avater">
            <a href="javascript:void(0);">
              <figure>
                <img src={iState?.profileImage} alt="internal server error" />
              </figure>
              Skyrixe
            </a>
            <ul>
              <li>
                <figure>
                <img src={iState?.profileImage} alt="internal server error" />
                </figure>
                <h4>
                  <span>{iState?.name}</span>
                </h4>
              </li>
              <li>
                <Link to={"/MyAccount"} state={iState}>
                  <span>
                    <i className="fa fa-user-o" aria-hidden="true" />
                  </span>{" "}
                  My Account
                </Link>
                <Link to={"/ChangePassword"}>
                  <span>
                    <i className="fa fa-cog" />
                  </span>{" "}
                  Change Password
                </Link>
                <Link
                  href="javascript:void(0);"
                  data-toggle="modal"
                  data-target="#LogOutModal"
                  to={"/login"}
                  onClick={() => {
                    // localStorage.removeItem('remberMe')
                    localStorage.removeItem("single_vendor_admin_token");
                  }}
                  replace
                >
                  <span>
                    <i className="fa fa-sign-out" />
                  </span>{" "}
                  Logout
                </Link>
              </li>
            </ul>
          </div>
          <div className="clear" />
        </div>
      </div>
    </>
  );
};

export default Header;
